window.DocumentosQuitadosController = ControllerBase.extend({ // FNX-4896
    name: "DocumentosQuitadosController", 
    framework: "knockout",

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'CPF/CNPJ', prop: 'CpfCnpj' },
            { title: 'Nome', prop: 'Nome' }
        ],
        getData: function () {

            var cliente = this.cliente
                 ? this.cliente
                 : ControllerBase.instances['CadastroClienteController'].model;

            return this.toJS(cliente);
        },
    }),

    tamanhoPagina: 20,
    totalGeral: 0.00,

    ajax: function() {
        return {
            url: "/Cliente/_DocumentosQuitados",
            type: "post",
            cache: false,
            data: {
                codigoCliente: this.orcamento ? this.orcamento.get("CodigoCliente") : this.cliente.get("Codigo"),
                tamanhoPagina: this.tamanhoPagina

            }
        };
    },

    atualizarPaginador: function(data) {

        this.paginador = new Paginator({
            container: "#page-documentos-quitados-cliente",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

    },


    aposBinding: function() {
        this.atualizarPaginador(this.toJS(this.model));

        var self = this;
        var oidCliente = this.orcamento ? this.orcamento.get("CodigoCliente") : this.cliente.get("Codigo");

        global.ajax({
            url: "/Cliente/ObterValorTotalDocumentosQuitados",
            type: "post",
            blockUI: false,
            contentType: "application/json",
            data: global.toJSONString({ OidCliente: oidCliente }),
            success: function (data) {

                if (!data || data.HasErrors) {
                    return;
                }
                self.TotalGeral = data;
                $("#Total_Geral_DOcumentos_Quitados").text(global.formatNumber(self.TotalGeral));
            }
        });

    },

    paginar: function(e) {
        this.pesquisar(null, null, e.page);
    },

    pesquisar: function (mode, e, pagina) {

        pagina = pagina || 1;

        var self = this;
        var oidCliente = this.orcamento ? this.orcamento.get("CodigoCliente") : this.cliente.get("Codigo");


        var filtros = {
            OidCliente: oidCliente,
            NumeroPagina: pagina,
            TamanhoPagina: this.tamanhoPagina,
        };

        global.ajax({
            url: "/Cliente/ListarDocumentosQuitados",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({ filtros: filtros }),
            success: function (data) {

                if (!data || data.HasErrors) {
                    return;
                }

                var m = ko.mapping.fromJS(data.Entities);
                self.model.Entities(m());
                self.atualizarPaginador(data);
            }
        });

    },

});